import { Create, Datagrid, DateField, Edit, EditButton, FormTab,NumberField, List, NumberInput, ReferenceField, ReferenceInput, required, SelectInput, Show, ShowButton, SimpleForm, SimpleShowLayout, TabbedForm, TextField, TextInput, AutocompleteInput, BooleanInput, BooleanField } from "react-admin";
import { useWatch } from "react-hook-form";

const CompanyInput = () => {
    const pId = useWatch({name:'parent_company_id'});
    return (<ReferenceInput source="company_id" filter={{parent_company_id:  pId }} reference="companies"><SelectInput optionText="name" /></ReferenceInput>);
};

export const ReimbursableTypeCreate = () => (
    <Create>
        <TabbedForm>
            <FormTab label="Reimbursable Type Details">
            <ReferenceInput source="parent_company_id" reference="parent_companies" validate={required()}><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
            <CompanyInput /> 
            <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} />
                <BooleanInput source="active" defaultValue={true} />
                <TextInput source="name" validate={required()} />
                <TextInput source="unit_type" label="Unit Type Ex:nos, lumpsum" validate={required()} />
                <NumberInput onWheel={e => e.target.blur()}  source="unit_cost" />
                <NumberInput onWheel={e => e.target.blur()}  source="total_quantity" />
                <NumberInput onWheel={e => e.target.blur()}  source="total_amount" />
            </FormTab>
            <FormTab label="Historical Details">
                <ReferenceInput source="history.reimbursable_report_id" reference="reimbursable_report" validate={required()} ><SelectInput optionText="name" value="id" label="Select Report of last month" fullWidth="true" /></ReferenceInput>
                <NumberInput onWheel={e => e.target.blur()}  source="history.balance_amount" label="Balance Amount as per above report" validate={required()} fullWidth="true" />
                <NumberInput onWheel={e => e.target.blur()}  source="history.balance_quantity" label="Balance Quantity as per above report" validate={required()} fullWidth="true" />
            </FormTab>
        </TabbedForm>
    </Create>
);

const reimbursableTypeFilter= [
    <ReferenceInput source="company_id" reference="companies" alwaysOn><SelectInput optionText="full_name" /></ReferenceInput>,
    <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} alwaysOn/>
];

export const ReimbursableTypeList = () => (
    <List filters={reimbursableTypeFilter}>
        <Datagrid  bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="name" />
            <BooleanField source="active" />
            <TextField source="unit_type" />
            <TextField source="unit_cost" />
            <TextField source="total_quantity" />
            <TextField source="total_amount" />
            <TextField source="currency" />
            <ReferenceField source="parent_company_id" reference="parent_companies"><TextField source="name" /></ReferenceField>
            <ReferenceField source="company_id" reference="companies"><TextField source="name" /></ReferenceField>
            <ShowButton label="View" />
            <EditButton label="Edit" />
        </Datagrid>
    </List>
);


export const ReimbursableTypeShow = () => (
    <Show>
        <SimpleShowLayout>
        <TextField source="id" />
            <TextField source="name" />
            <BooleanField source="active" />
            <TextField source="unit_type" />
            <TextField source="unit_cost" />
            <DateField source="total_quantity" />
            <TextField source="total_amount" />
            <TextField source="currency" />
            <ReferenceField source="company_id" reference="companies"><TextField source="full_name"/></ReferenceField>
        </SimpleShowLayout>
    </Show>
);

export const ReimbursableTypeEdit = () => (
    <Edit>
        <SimpleForm>
            <ReferenceInput source="parent_company_id" reference="parent_companies"><SelectInput optionText="name" /></ReferenceInput>
            <ReferenceInput source="company_id" reference="companies"><SelectInput optionText="name" /></ReferenceInput>
                <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} />
                <BooleanInput source="active" />
                <TextInput source="name" validate={required()} />
                <TextInput source="unit_type" label="Unit Type Ex:nos, lumpsum" validate={required()} />
                <NumberInput onWheel={e => e.target.blur()}  source="unit_cost" />
                <NumberInput onWheel={e => e.target.blur()}  source="total_quantity" />
                <NumberInput onWheel={e => e.target.blur()}  source="total_amount" />
        </SimpleForm>
    </Edit>
);

const reimbursableHistoricalDataFilter = [
    <ReferenceInput source="reimbursable_report_id" reference="reimbursable_report" alwaysOn><SelectInput optionText="name" optionValue="id" /></ReferenceInput>,
    <ReferenceInput source="company_id" reference="companies" validate={required()} alwaysOn><SelectInput optionText="full_name" optionValue="id" /></ReferenceInput>,
];

export const ReimbursementTypeHistoricalDataList = () => (
    <List filters={reimbursableHistoricalDataFilter}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="id" validate={required()} />
            <ReferenceField source="reimbursable_type_id" reference="reimbursable_type" ><TextField source="name" /></ReferenceField>
            <ReferenceField source="company_id" reference="companies" label="Company Name"><TextField source="name" /></ReferenceField>
            <ReferenceField source="reimbursable_report_id" reference="reimbursable_report" label="Report"><TextField source="name" /></ReferenceField>
            <NumberField source="till_amount" />
            <NumberField source="cumulative_amount" />
            <NumberField source="balance_amount" />
            <EditButton label="Edit"/>
        </Datagrid>
    </List>
);
const ReimbursableTypeInput = props => {
    var company = useWatch({ name: 'company_id' });
    var currency = useWatch({name: 'currency'});
    // const values = getValues();
    if (company == null || company === '') {
        company = 99;
    }
    return (
        <ReferenceInput source="reimbursable_type_id" reference="reimbursable_type" fullWidth="true" filter={{ company_id: company, currency:currency,active:true }}><AutocompleteInput source="name" fullWidth /></ReferenceInput>
    );
};

export const reimbursementTypeHistoricalDataCreate = () => (
    <Create>
        <SimpleForm>
        <ReferenceInput source="company_id" reference="companies" label="Company Name" validate={required()}><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
        <SelectInput source="currency" choices={[
                    { id: 'INR', name: 'INR' },
                    { id: 'USD', name: 'USD' },
                    { id: 'JPY', name: 'JPY' },
                ]} validate={required()} />
         <ReimbursableTypeInput validate={required()} />
            <ReferenceInput source="reimbursable_report_id" reference="reimbursable_report" label="Report" validate={required()}><SelectInput optionText="name" optionValue="id" /></ReferenceInput>
            <NumberInput source="till_amount" />
            <NumberInput source="till_quantity" />
            <NumberInput source="cumulative_amount" />
            <NumberInput source="cumulative_quantity" />
            <NumberInput source="balance_amount" />
            <NumberInput source="balance_quantity" />
        </SimpleForm>
    </Create>
);

export const ReimbursementTypeHistoricalDataShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" validate={required()} />
            <ReferenceField source="reimbursable_type_id" reference="reimbursable_type" ><TextField source="name" /></ReferenceField>
            <ReferenceField source="company_id" reference="companies" label="Company Name"><TextField source="name" /></ReferenceField>
            <ReferenceField source="reimbursable_report_id" reference="reimbursable_report" label="Report"><TextField source="name" /></ReferenceField>
            <NumberField source="till_amount" />
            <NumberField source="cumulative_amount" />
            <NumberField source="balance_amount" />
        </SimpleShowLayout>
    </Show>
);

export const ReimbursementTypeHistoricalDataEdit = () => (
    <Edit>
        <SimpleForm>
            <TextField source="id" validate={required()} />
            <ReferenceField source="reimbursable_type_id" reference="reimbursable_type" ><TextField source="name" /></ReferenceField>
            <ReferenceField source="company_id" reference="companies" label="Company Name"><TextField source="name" /></ReferenceField>
            <ReferenceField source="reimbursable_report_id" reference="reimbursable_report" label="Report"><TextField source="name" /></ReferenceField>
            <NumberInput source="till_amount" onWheel={e => e.target.blur()}  />
            <NumberInput source="cumulative_amount" onWheel={e => e.target.blur()}  />
            <NumberInput source="balance_amount" onWheel={e => e.target.blur()}  />
        </SimpleForm>
    </Edit>
);